export default __webpack_public_path__ + "static/media/m_r.ed8dc14e.wav";